import { render, staticRenderFns } from "./RoleLinks.vue?vue&type=template&id=89d77ae8&scoped=true&"
import script from "./RoleLinks.vue?vue&type=script&lang=js&"
export * from "./RoleLinks.vue?vue&type=script&lang=js&"
import style0 from "./RoleLinks.vue?vue&type=style&index=0&id=89d77ae8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d77ae8",
  null
  
)

export default component.exports